var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-wrap',[_c('div',{staticClass:"edit-header--back",on:{"click":_setup.handleBack}},[_c('i',{staticClass:"el-icon-back"}),_c('span',[_vm._v(" 返回")])]),_c(_setup.TranslateContent,{ref:"translateRef",attrs:{"translate-res":_setup.translateRes},on:{"edit-res":_setup.handleEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }